<!-- 
Panel for showing notice email content.
-->
<template>
  <div>
    <our-data-container v-if="notice" dense>
      <our-data-field v-if="to" label="To"><div v-for="item in to" :key="item">{{ item }}</div></our-data-field>
      <our-data-field v-if="cc" label="Cc"><div v-for="item in cc" :key="item">{{ item }}</div></our-data-field>
      <our-data-field v-if="subject" label-width="10" label="Subject">{{ subject }}</our-data-field>
      <template v-if="notice.attachmentName">
        <our-data-field label-width="11" label="Attachment">
          {{ notice.attachmentName }}
        </our-data-field>
        <v-flex v-if="notice.id" xs10 offset-xs1>
          <notice-attachment-panel ref="attachment" :attachment-name="notice.attachmentName" :notice-id="notice.id"/>
        </v-flex>
      </template>
      <our-data-field label-width="11" label="Content">
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <v-flex class="email-content scrollable-view pa-3" v-html="body" />
      </our-data-field>
    </our-data-container>
    <our-loading-indicator v-else />
  </div>
</template>

<script>
import NoticeAttachmentPanel from "@/components/notices/NoticeAttachmentPanel.vue";

export default {
  components: {
    NoticeAttachmentPanel
  },
  props: {
    notice: {
      type: Object,
      default: null
    },
    hideRecipients: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showRecipients() {
      return !this.hideRecipients;
    },
    to() {
      return this.showRecipients && this.notice ? this.getRecipients(this.notice.to) : null;
    },
    cc() {
      return this.showRecipients && this.notice ? this.getRecipients(this.notice.cc) : null;
    },
    subject() {
      return this.notice ? this.notice.subject : null;
    },
    body() {
      return this.notice ? this.notice.body : null;
    }
  },
  methods: {
    reset() {
      if (this.$refs.attachment) this.$refs.attachment.collapse();
    },
    getRecipients(values) {
      return values ? values.split(/[\s,;]+/) : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.scrollable-view {
  max-height: 350px;
}
</style>